const tooltips = {
  teremberles: 'Terembérlés karbantartására szolgáló felület, fizetés funkcióval. Csak azok a helyszínek láthatóak a felhasználó számára, amelyeknek a szerepköre a felhasználóhoz van rendelve.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
